<template>
  <div class="a">
    <Nav/>
    <PageBannerBig :banner="banner"></PageBannerBig>
    <div class="service-content">
      <div class="content">
        <div class="title-name">地产行业解决方案</div>
        <div class="title-sub">概述</div>
        <div class="text">
          橡诺地产工程质管解决方案以建筑工程质量管理体系理论为基础，立足于地产行业业务实践，实现了地产行业工程管理项目全生命周期质量动态管控。解决了地产行业因项目周期长、变化快、复杂度高等因素带来的质量管理问题，实现信息和知识的有效管理及流程的严格把控，全面提升企业项目质量管理水平。通过严谨的管控机制和权威的报表分析，为企业在质量管理上多一份保障。
        </div>
        <div class="title-sub">解决方案</div>
        <div class="text">
          橡诺地产工程质管解决方案建立完善的在建工程知识体系，做到流程标准化,数据标准化,验收标准化、从而实现设计施工验收一体化。及时的任务跟踪预警为企业提供质量安全的一道屏障。准确的验收标准、快捷的验证留存、快速的整改跟进为企业在质管过程中能够高效便捷的管理。<br>
          根据客户实际业务，设置清晰合理的模块、流程和事务处理，使客户可以简单便捷的操作管理。通过强大的资料信息库以及查询、汇总、分析等强大功能，为用户质管提供强有力的支撑。<br>
          橡诺地产工程质管解决方案包括质量计划、检查验收、问题管理、绩效考核、报表档案以及系统管理等模块。
          <div class="img"><img src="@/assets/img/solution/4/1.png"></div>
        </div>
        <div class="title-sub">客户收益</div>
        <div class="text">
          360°全面项目监控，降低项目风险<br>
          通过对项目设计、项目施工、项目验收的全过程的监控，保证所有质量事件均在受控的环境中被记录、调查和整改，帮助用户有问题早发现早解决，大大降低项目监管和质量风险。<br>
          管理标准化，降低管理成本
          <br>通过系统帮助用户建立标准化和自动化的管理流程，帮助用户提高工作效率。通过对质量管理工作的合理规划和有效执行，减小质量工作对生产的影响。
        </div>
      </div>
      <Mission/>
    </div>

    <Contact/>
    <Footer/>
  </div>
</template>

<script>
import Nav from '@/components/Nav'
import PageBannerBig from '@/components/PageBannerBig'
import Contact from '@/components/Contact'
import Footer from '@/components/Footer'
export default {
  name: '',
  components: {
    Nav,
    PageBannerBig,
    Contact,
    Footer
  },
  data () {
    return {
      banner: {
        img: require("@/assets/img/solution-banner.jpg"),
        title: "为您提供专业的解决方案",
        sub: "专业的服务 高效的方案"
      }
    }
  }
}
</script>

<style scoped lang="less">
.service-content{
    width: 100%;
    padding-bottom: 100px;
    display: flex;
    flex-direction: column;
    align-items: center;
    box-sizing: border-box;
    background-image: url(../../assets/img/service-bg.png);
    background-repeat: no-repeat;
    background-position: center;
    background-size: cover;
    .content{
      width: 1200px;
      display: flex;
      flex-direction: column;
      box-sizing: border-box;
      .title-name{
        height: 38px;
        color: #333333;
        transform: .5s;
        line-height: 38px;
        font-size: 30px;
        margin-top: 80px;
        margin-bottom: 38px;
        text-align: center;
        box-sizing: border-box;
      }
      .title-sub{
        color: #333;
        line-height: 24px;
        font-size: 20px;
        text-align: left;
        box-sizing: border-box;
        width: 200px;
        margin-top: 30px;
        margin-bottom: 10px;
        border-radius: 30px;
      }
      .text{
        color: #666;
        line-height: 24px;
        font-size: 14px;
        box-sizing: border-box;
        .img{
          padding: 30px;
          margin: 20px auto;
          background: #fff;
          text-align: center;
        }
      }
    }
}
</style>